define('home/views/ProfileCommentsModuleView',[
    'backbone-marionette',

    'home/views/ProfileCommentsModulePostView',
    'home/templates/profileCommentsModule',
], function (
    Marionette,

    ProfileCommentsModulePostView,
    profileCommentsModuleTemplate
) {
    'use strict';

    var ProfileCommentsModuleView = Marionette.CompositeView.extend({
        template: profileCommentsModuleTemplate,
        className: 'aside__wrap -padded',

        itemView: ProfileCommentsModulePostView,
        itemViewContainer: '[data-role=posts]',

        itemViewOptions: function (_item, index) {
            // Only show the first 3 items
            if (index > 2)
                return { className: 'hidden' };
        },
    });

    return ProfileCommentsModuleView;
});

